import { AnyAction } from '@reduxjs/toolkit'
import { Middleware } from 'redux'

import { RootState } from 'store/rootReducer'
import { addToFavorites, removeFromFavorites } from 'store/slices/favorites'

import { fetchProductsByCodes } from '@/entities/product'

import { mindBoxSDK } from '@/shared/integrations/mindBox'
import { getPhoneFromJwtToken } from '@/shared/lib/utils/jwt/get-phone-from-jwt-token'
import { isBrowserEnv } from '@/shared/lib/utils/next/isBrowserEnv'

/**
 * Middleware for transmitting data about user actions to MindBox
 */
// TODO EK
export const mindBoxMiddleware: Middleware =
	({ getState }) =>
	next =>
	async (action: AnyAction) => {
		const result = next(action)
		const state: RootState = getState()

		if (isBrowserEnv()) {
			// On adding to the favorites list
			if (addToFavorites.match(action) || removeFromFavorites.match(action)) {
				const userPhone = getPhoneFromJwtToken(state?.session?.token)
				const favoriteProducts = !!state.favorites.items?.length
					? await fetchProductsByCodes(state.favorites.items)
					: []

				if (favoriteProducts) {
					mindBoxSDK.sendEditFavoritesListEvent(favoriteProducts, userPhone)
				}
			}

			return result
		}
	}
